import { render, staticRenderFns } from "./TheDappCenterLayout.vue?vue&type=template&id=513130cd&"
import script from "./TheDappCenterLayout.vue?vue&type=script&lang=js&"
export * from "./TheDappCenterLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports